import React from 'react'
import { Card, Col, Row } from 'react-bootstrap'
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { isMobile } from 'react-device-detect';
import VideoPlayer from '../../common/VideoPlayer';

const Photogrammetry = () => {
    const responsive = {
        desktop: {
          breakpoint: { max: 5000, min: 1024 },
          items: 1,
        },
        tablet: {
          breakpoint: { max: 1024, min: 464 },
          items: 1,
        },
        mobile: {
          breakpoint: { max: 464, min: 0 },
          items: 1,
        }
      };
  return (
    <>
         <Card className='no-border rounded-0 architectural-modeling container'>
            <Card className='text-center no-border rounded-0'>
                <Card.Body>
                    <Card.Title className='architectural-modeling-title'> 写真測量(フォトグラメトリー)による真正性の確保と最適化 </Card.Title>
                    <Card.Text className='architectural-modeling-text text-left'>
                    参照画像からのデジタルツインの手動モデリングやエンジニアリングCADファイルの変換に加え、私たちは、実際のオブジェクトや場所の数百または数千の写真を3Dデジタルツインに変換する写真測量（フォトグラメトリー）に精通しています。この技術による3Dモデルは、穴や隙間のある溶解しているようなモデルや、ARやVRに適さない数百万ポリゴンの高負荷なモデルなどの様々な問題が指摘されています。
                    しかし、私たちは、高精細な写真のテクスチャと、最適化・単純化した3Dモデルを融合する技術を開発し、このような問題を解決しています。
                    <br />
                    <br /> 
                    私たちのチームは、世界中の実在する場所の写真を撮影し、その写真から、実物に極めて近く、かつ高性能な3Dモデルを構築することができます。例えば、広大なパシュパティナート寺院の一部をデジタルツインとして再現し、VRで見学することができます。ネパールのカトマンズにあるこの寺院は、ヒンズー教の第三の聖地であり、巡礼の地でもあります。これに加えて、焼香や、実写の360°フォトスフィア、360°ビデオを頭にかざすことで、寺院をリアルに見たり、物語を読んだりできるインタラクティブな 体験を可能にしました。
                    </Card.Text>

                    <div className="pashupatinath-carousel-body">
                    <Carousel
                     responsive={responsive}
                     autoPlay={false}
                     arrows={isMobile ? false : true }
                     centerMode={ isMobile ? false : true }
                     slidesToSlide={1}
                     infinite={true}
                     showDots={true}
                    //  keyBoardControl={true}
                     renderDotsOutside={true}
                     draggable={false}
                     autoPlaySpeed={3000}
                    >
                        <div>
                            <img className="d-block w-100 px-md-2" src={"/assets/digital-twin/photogrammetry/images/ph_001.jpg"} alt="" />
                        </div>
                        <div>
                            <img className="d-block w-100 px-md-2" src={"/assets/digital-twin/photogrammetry/images/ph_002.jpg"} alt="" />
                        </div>
                        <div>
                            <img className="d-block w-100 px-md-2" src={"/assets/digital-twin/photogrammetry/images/ph_003.jpg"} alt="" />
                        </div>
                    </Carousel>
                    </div>
                </Card.Body>
            </Card>
            <Card className='no-border rounded-0'>
                <Row>
                    <Col md={{span:8, offset:2}} className="my-md-3 py-md-4">
                        <VideoPlayer videosource="/assets/digital-twin/photogrammetry/video/pashupatinath-photogrammetry.mp4" class="winery-video container" />
                    </Col>

                    <Col md={{span:8, offset:2}} className="my-md-3 py-md-4">
                        <Card.Subtitle className='pashupatinath-subtitle'> パシュパティナートのフライスルー動画 </Card.Subtitle>
                        <VideoPlayer videosource="/assets/digital-twin/photogrammetry/video/pashupatinath-flythrough.mp4" class="winery-video container  " />
                    </Col>

                </Row>
            </Card>
        </Card>
      
    </>
  )
}

export default Photogrammetry
